import type { ComponentProps } from 'react';
import { useRecordContext } from 'ra-core';
import { Badge } from '../../components/ui/badge';
import { cn } from '../../lib/utils';
import type { FieldProps } from '../../lib/field.type';

type BadgeVariant = ComponentProps<typeof Badge>['variant'];

export interface StringArrayBadgeFieldProps<
  RecordType extends Record<string, any> = Record<string, any>,
> extends FieldProps<RecordType> {
  variant?: BadgeVariant;
  className?: string;
}

/** Renders an array-valued record field as wrapping badges. */
export function StringArrayBadgeField<
  RecordType extends Record<string, any> = Record<string, any>,
>({
  source,
  variant = 'secondary',
  className,
}: StringArrayBadgeFieldProps<RecordType>) {
  const record = useRecordContext<RecordType>();
  const values = record?.[source];

  if (!Array.isArray(values)) {
    return null;
  }

  return (
    <div className={cn('flex flex-wrap gap-1', className)}>
      {values.map((value: unknown, index: number) => {
        const label = String(value);

        return (
          <Badge key={`${label}-${index}`} variant={variant}>
            {label}
          </Badge>
        );
      })}
    </div>
  );
}
